module.exports = __webpack_public_path__ + "static/lego-components-good-c643512d2bf72199f1d83bf43eec4e44.jpeg";